@let _icon = icon();

<div class="notify" [ngClass]="'notify-color-' + color()">
  @if (_icon) {
    <div class="notify-icon">
      <app-svg-icon [name]="_icon"></app-svg-icon>
    </div>
  }

  <div class="notify-content" (click)="closeElement.emit()" tabindex="0">
    <ng-content></ng-content>
  </div>

  @if (showClose()) {
    <div class="notify-close" (click)="closeElement.emit()" tabindex="0">
      <app-svg-icon [name]="'close'"></app-svg-icon>
    </div>
  }
</div>
